import React from 'react';
import { FormField } from '../../FormField/FormField';
import { ExternalUserField } from '../../ExternalUserField/ExternalUserField';
import { Reservation } from '../../../types/reservation';
import { ReservationType } from '../../../types/reservationType';
import { ExternalUser, ExternalUserShort } from '../../../types/externalUser';
import { ReservationFormFieldProps } from '../types';

interface Props extends ReservationFormFieldProps {
  isCreating: boolean;
  isModifying: boolean;
  isPast: boolean;
  showRequiredFields: boolean;
  preselectedExternalUser: ExternalUser | undefined;
  reservationType: ReservationType;
  resource: Reservation | undefined;
  renderUserAttendance: (user: ExternalUserShort) => React.ReactNode;
}

/** The client of an individual reservation. */
export const ClientField = ({
  form,
  setFormFields,
  validationErrors,
  isCreating,
  isModifying,
  isPast,
  showRequiredFields,
  preselectedExternalUser,
  reservationType,
  resource,
  renderUserAttendance,
}: Props) => {
  return (
    <FormField
      labelTitle='Cliente'
      elementId='reservation-user'
      fullWidth
      error={validationErrors?.externalUsers}
      required={showRequiredFields}
    >
      <ExternalUserField
        isModifying={isCreating && !preselectedExternalUser}
        user={form?.confirmedExternalUsers?.[0] ?? form?.externalUsers?.[0]}
        onChange={(externalUser) => {
          setFormFields({
            externalUsers: [externalUser],
            useCoupon: !!externalUser.userCouponsHaveUsesRemaining,
            userCouponId: externalUser.userCouponsHaveUsesRemaining ? externalUser.userCouponIds?.[0] : undefined,
            price: externalUser.userCouponsHaveUsesRemaining ? 0 : undefined,
            typeOfCouponToUse: undefined,
            selectedUserToShareCoupon: undefined,
          });
        }}
        error={validationErrors?.externalUsers}
        {...(!isModifying && {
          navigateTo: `/users/profile/${resource?.confirmedExternalUsers?.[0]?.id}`,
        })}
      />
      {!isCreating &&
        form?.confirmedExternalUsers?.[0] &&
        isPast &&
        reservationType.hasAttendance &&
        renderUserAttendance(form.confirmedExternalUsers[0])}
    </FormField>
  );
};
